<template>
  <div class="container">
    <h1 class="mb-4">Pago {{ payment.id }} de Comisión {{ payment.comision_id }}</h1>

    <div class="details">
      <div class="details__head">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item tabs-item">
            <a class="nav-link active" data-toggle="tab" role="tab" href="#details">
              <fai icon="info"/>&nbsp;Generales
            </a>
          </li>
        </ul>
      </div>
      <div class="details__body mt-4">
        <div class="tab-content">
          <!--begin: Details -->
          <div id="details" class="tab-pane fade show active" role="tabpanel" v-if="payment.id">
            <div class="row">
              <div class="col-sm-6">
                <h4 class="m--font-info">Datos Generales</h4>
              </div>
              <div class="col-sm-6 text-right">
                <button class="btn btn-secondary" @click="$router.go(-1)">
                  <fai icon="reply"/> Cancelar
                </button>
                <button v-if="payment.file_url==null" class="btn btn-danger" @click="deletePayment">
                  <fai icon="trash"/> Eliminar
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6 col-md-3">
                  <h5>Impulsor</h5>
                  <span>{{ payment.promoter }}</span>
              </div>
              <div class="col-sm-6 col-md-3">
                  <h5>Comisión</h5>
                  <span>{{ payment.comision_id }}</span>
              </div>
              <div class="col-sm-6 col-md-3">
                  <h5>Aplica IVA</h5>
                  <span>{{ (payment.iva) ? 'Sí' : 'No' }}</span>
              </div>
              <div class="col-sm-6 col-md-3">
                  <h5>Fecha de Pago</h5>
                  <span>{{ payment.date_payment | formatDate }}</span>
              </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-6 col-md-3">
                    <h5>Monto del pago</h5>
                    <span>{{ payment.amount | formatCurrency }}</span>
                </div>
                <div class="col-sm-6 col-md-3">
                    <h5>Monto IVA</h5>
                    <span>{{ payment.iva_amount | formatCurrency }}</span>
                </div>
            </div>
            <hr class="mt-4"/>
            <div class="row">
                <div class="col-sm col-md col-lg">
                    <h4 class="m--font-info">Anexo</h4>
                </div>
            </div>
            <div class="mt-2" v-if="attachment.id">
              <div class="row">
                <div class="col">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Inversionista</th>
                        <th scope="col">Contrato</th>
                        <th scope="col">Fecha de inicio</th>
                        <th scope="col">Fecha de vencimiento</th>
                        <th scope="col">Monto de inversión</th>
                        <th scope="col">Comisión</th>
                        <th scope="col">Monto Pagado</th>
                        <th scope="col">Monto por Pagar</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row" class="text-success">{{ attachment.attachment_id }}</th>
                        <td>{{ attachment.investor_name }}</td>
                        <td>{{ attachment.contract_folio }}</td>
                        <td>{{ attachment.date_init | formatDate }}</td>
                        <td>{{ attachment.date_expire | formatDate }}</td>
                        <td>{{ attachment.amount | formatCurrency }}</td>
                        <td>{{ attachment.comision_amount | formatCurrency }}</td>
                        <td>{{ attachment.payed_amount | formatCurrency }}</td>
                        <td>{{ attachment.avaliable_amount | formatCurrency }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="mt-2" v-if="monthly_cut_attachment.id">
              <div class="row">
                <div class="col">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Inversionista</th>
                        <th scope="col">Contrato</th>
                        <th scope="col">Fecha de inicio</th>
                        <th scope="col">Fecha de vencimiento</th>
                        <th scope="col">Intereses</th>
                        <th scope="col">Comisión</th>
                        <th scope="col">Monto Pagado</th>
                        <th scope="col">Monto por Pagar</th>
                        <th scope="col">Tipo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row" class="text-success">{{ monthly_cut_attachment.attachment_id }}</th>
                        <td>{{ monthly_cut_attachment.investor }}</td>
                        <td>{{ monthly_cut_attachment.contract }}</td>
                        <td>{{ monthly_cut_attachment.init_date | formatDate }}</td>
                        <td>{{ monthly_cut_attachment.end_date | formatDate }}</td>
                        <td>{{ monthly_cut_attachment.net_interest | formatCurrency }}</td>
                        <td>{{ monthly_cut_attachment.comision_amount | formatCurrency }}</td>
                        <td>{{ monthly_cut_attachment.payed_amount | formatCurrency }}</td>
                        <td>{{ monthly_cut_attachment.avaliable_amount | formatCurrency }}</td>
                        <td>Intereses Netos</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <hr class="mt-4"/>
            <div class="row">
              <div class="col-sm col-md col-lg">
                <h4 class="m--font-info">Comprobante de Pago</h4>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                <a target="_blank" v-if="payment.file_url" :href="payment.file_url">Descargar comprobante</a>
                <h5>Subir comprobante</h5>
                <vue-dropzone
                  ref="contractDropzone"
                  @vdropzone-success="successDropzone"
                  id="dropzone"
                  :options="dropzoneOptions">
                </vue-dropzone>
              </div>
            </div>
            <hr class="mt-4"/>
            <div class="row">
                <div class="col">
                    <h4 class="m--font-info">Registro</h4>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-6 col-md-6">
                    <h5>Registrado Por</h5>
                    <span>{{ payment.created_by }}</span>
                </div>
                <div class="col-sm-6 col-md-6">
                    <h5>Fecha de Registro</h5>
                    <span>{{ payment.created_at }}</span>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PromotersService from '@/services/promoters'
import SysTable from '@/components/shared/Table'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import apiConfig from '@/services/api-config'
import store from '@/store'

export default {
  components: { SysTable, vueDropzone: vue2Dropzone },

  data () {
    return {
      payment: {},
      comision: {},
      attachment: {},
      monthly_cut_attachment: {},
      dropzoneOptions: {
        url: `${apiConfig.apiUrl}/promoter_payment/${this.$route.params.id}/document`,
        headers: {
          Authorization: store.getters.getToken
        },
        maxFiles: 1
      }
    }
  },
  beforeCreate: function () {
    const id = this.$route.params.id
    PromotersService.getPayment(id).then(res => {
      this.payment = res.data
      if (this.payment.monthly_cut_attachment_id) {
        PromotersService.getMonthlyCutAttachment(this.payment.monthly_cut_attachment_id).then(res => {
          this.monthly_cut_attachment = res.data
        })
      } else {
        PromotersService.getAttachment(this.payment.attachment_id).then(res => {
          this.attachment = res.data
        })
      }
    })
  },
  methods: {
    successDropzone (file, response) {
      this.$refs.contractDropzone.removeAllFiles()
      this.payment.file_url = response.file_url
    },
    deletePayment () {
      const id = this.$route.params.id

      this.$swal({
        title: '¿Deseas borrar el pago?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          PromotersService.deletePayment(id).then(res => {
            this.$swal('El pago ha sido eliminado', {
              icon: 'success'
            })
            this.$router.go(-1)
          }).catch(err => {
            this.$swal(err.message, 'Favor de intentar nuevamente', {
              icon: 'error'
            })
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.download-card {
    display: flex;
    margin: 10px 0;
}

.remove{
  color: red;
}

.download-details {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/promoters/payments/PaymentDetail.vue